export default "__VITE_ASSET__CmyrnPqC__"